import { render, staticRenderFns } from "./VulnerabilityDetailsModal.vue?vue&type=template&id=5bfe2bc8&scoped=true&"
import script from "./VulnerabilityDetailsModal.vue?vue&type=script&lang=js&"
export * from "./VulnerabilityDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./VulnerabilityDetailsModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VulnerabilityDetailsModal.vue?vue&type=style&index=1&id=5bfe2bc8&scoped=true&lang=css&"
import style2 from "./VulnerabilityDetailsModal.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe2bc8",
  null
  
)

export default component.exports